/**
 * TanStack Query hooks for `appmetrica-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	appmetricaIntegrationQueryKeys,
	type CreateAppmetricaIntegrationBody,
	type ListAppmetricaIntegrationResponse,
	type AppmetricaIntegrationRow,
} from "./api";

export function useAppmetricaIntegrationList(): UseQueryResult<ListAppmetricaIntegrationResponse, Error> {
	return useQuery({
		queryKey: appmetricaIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useAppmetricaIntegrationCreate(): UseMutationResult<AppmetricaIntegrationRow, Error, CreateAppmetricaIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: appmetricaIntegrationQueryKeys.all });
		},
	});
}

export function useAppmetricaIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: appmetricaIntegrationQueryKeys.all });
		},
	});
}
